
import React, { useEffect } from 'react';
import { setTitle } from '../../shared/services/general/general-service';
import Footer from '../../components/footer/footer';

export default function Dmca () {
	useEffect(() => {
		setTitle('قانون کپی رایت (DMCA)');
	}, []);

	return (<>
		<div className="d-flex flex-column container" style={{maxWidth: '1440px', width: '100%', margin: '30px auto' }}>
			<br />
			<br />
			<div className="max-width-menu section-title clearfix"><h1>قانون کپی رایت (DMCA)</h1></div>
			<br />
			<div style={{padding:'30px', direction: 'ltr'}}>
				<h1>DMCA Policy</h1>
				<p><strong>Effective Date:</strong> December 30, 2024</p>

				<p>Bebin.com respects copyright laws and complies with the Digital Millennium Copyright Act (DMCA). If
					you believe any content on our platform infringes your copyright, please notify us with the
					following details:</p>

				<ul>
					<li><strong>Your Information:</strong> Name, address, email, and phone number.</li>
					<li><strong>Description of Copyrighted Work:</strong> Identify the material you claim is infringed.
					</li>
					<li><strong>Location of Infringing Content:</strong> Provide the specific URL(s) on our website.
					</li>
					<li><strong>Statement of Good Faith:</strong> Confirm that you believe the use is unauthorized.</li>
					<li><strong>Your Signature:</strong> Physical or electronic.</li>
				</ul>

				<p>Send your DMCA notice to:</p>
				<p><strong>Email:</strong> <a href="mailto:info@bebin.com" style={{color: '#8236FD'}}>info@bebin.com</a></p>

				<p>If you believe content was removed in error, you may submit a Counter-Notification including similar
					details.</p>

				<p>We reserve the right to remove infringing content and terminate repeat offenders. For third-party
					links, please contact the hosting provider directly.</p>

				<p><strong>Contact us:</strong></p>
				<p><a href="mailto:info@bebin.com" style={{color: '#8236FD'}}>info@bebin.com</a></p>
			</div>
		</div>
		<Footer></Footer>
	</>);
}
